import {
  RegistrationStepType,
  StaticRegistrationStepOptionLabel,
  RegistrationStepOptionMode,
  TeamType
} from '../../types/eventTypes';
import { IGameEventConfig, IRegistrationStep } from '../events';

const REGISTRATION_STEPS: IRegistrationStep[] = [
  {
    type: RegistrationStepType.SYNC_YOUR_BLIZZARD_ACCOUNT,
    options: [
      {
        label: StaticRegistrationStepOptionLabel.BATTLE_TAG,
        supportsModes: [RegistrationStepOptionMode.REQUIRED, RegistrationStepOptionMode.OPTIONAL]
      },
      {
        label: StaticRegistrationStepOptionLabel.TOURNAMENT_REGION,
        supportsModes: [
          RegistrationStepOptionMode.HIDDEN,
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.BLIZZARD_ACCOUNT_EMAIL,
        supportsModes: [
          RegistrationStepOptionMode.HIDDEN,
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.CONFIRM_REGISTRATION_DATA,
        supportsModes: [RegistrationStepOptionMode.HIDDEN, RegistrationStepOptionMode.REQUIRED]
      }
    ]
  },
  {
    type: RegistrationStepType.CLAIM_YOUR_CHARACTERS,
    options: [
      {
        label: StaticRegistrationStepOptionLabel.CLAIMED_CHARACTERS,
        supportsModes: [RegistrationStepOptionMode.REQUIRED, RegistrationStepOptionMode.OPTIONAL]
      },
      {
        label: StaticRegistrationStepOptionLabel.CONFIRM_REGISTRATION_DATA,
        supportsModes: [RegistrationStepOptionMode.HIDDEN, RegistrationStepOptionMode.REQUIRED]
      }
    ]
  },
  {
    type: RegistrationStepType.VERIFY_SOCIAL_AND_CONTACT_DETAILS,
    options: [
      {
        label: StaticRegistrationStepOptionLabel.ACCOUNT_EMAIL,
        supportsModes: [
          RegistrationStepOptionMode.HIDDEN,
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.WECHAT_ID,
        supportsModes: [
          RegistrationStepOptionMode.HIDDEN,
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.DISCORD_TAG,
        supportsModes: [
          RegistrationStepOptionMode.HIDDEN,
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.YOUTUBE_PROFILE,
        supportsModes: [
          RegistrationStepOptionMode.HIDDEN,
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.TWITCH_PROFILE,
        supportsModes: [
          RegistrationStepOptionMode.HIDDEN,
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.DOUYU_PROFILE,
        supportsModes: [
          RegistrationStepOptionMode.HIDDEN,
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.TWITTER_PROFILE,
        supportsModes: [
          RegistrationStepOptionMode.HIDDEN,
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.CONFIRM_REGISTRATION_DATA,
        supportsModes: [RegistrationStepOptionMode.HIDDEN, RegistrationStepOptionMode.REQUIRED]
      }
    ]
  },
  {
    type: RegistrationStepType.SETUP_RAIDERIO_CLIENT,
    options: [
      {
        label: StaticRegistrationStepOptionLabel.DESKTOP_CLIENT_INSTALLED,
        supportsModes: [
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.RECOMMENDED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.DESKTOP_CLIENT_HAS_BEEN_RUN_RECENTLY,
        supportsModes: [
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.RECOMMENDED,
          RegistrationStepOptionMode.OPTIONAL
        ]
      }
    ]
  },
  {
    type: RegistrationStepType.STREAMER_REGISTRATION,
    options: [
      {
        label: StaticRegistrationStepOptionLabel.TWITCH_PROFILE,
        supportsModes: [
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL,
          RegistrationStepOptionMode.HIDDEN
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.DOUYU_PROFILE,
        supportsModes: [
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL,
          RegistrationStepOptionMode.HIDDEN
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.YOUTUBE_PROFILE,
        supportsModes: [
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL,
          RegistrationStepOptionMode.HIDDEN
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.STREAMER_SCHEDULE,
        supportsModes: [
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL,
          RegistrationStepOptionMode.HIDDEN
        ]
      },
      {
        label: StaticRegistrationStepOptionLabel.STREAMER_AGREED,
        supportsModes: [
          RegistrationStepOptionMode.REQUIRED,
          RegistrationStepOptionMode.OPTIONAL,
          RegistrationStepOptionMode.HIDDEN
        ]
      }
    ]
  },
  {
    type: RegistrationStepType.SELECT_TEAM,
    options: [
      {
        label: StaticRegistrationStepOptionLabel.CHOOSE_TEAM,
        supportsModes: [RegistrationStepOptionMode.REQUIRED, RegistrationStepOptionMode.OPTIONAL],
        value: TeamType.MYTHICPLUS
      }
    ]
  },
  {
    type: RegistrationStepType.AGREE_TO_TERMS,
    options: [
      {
        label: StaticRegistrationStepOptionLabel.AGREE_TO_TERMS,
        supportsModes: [RegistrationStepOptionMode.REQUIRED, RegistrationStepOptionMode.OPTIONAL]
      }
    ]
  },
  {
    type: RegistrationStepType.BUILDER,
    options: []
  },
  {
    type: RegistrationStepType.BB_CODE,
    options: []
  },
  {
    type: RegistrationStepType.SYNC_MYTHIC_PLUS_CHARACTERS,
    options: [
      {
        label: StaticRegistrationStepOptionLabel.CHARACTER,
        supportsModes: [RegistrationStepOptionMode.REQUIRED, RegistrationStepOptionMode.OPTIONAL]
      },
      {
        label: StaticRegistrationStepOptionLabel.ROLE,
        supportsModes: [RegistrationStepOptionMode.REQUIRED, RegistrationStepOptionMode.OPTIONAL]
      },
      {
        label: StaticRegistrationStepOptionLabel.YOUR_TOP_MYTHIC_PLUS_SCORE_IS_AT_LEAST,
        supportsModes: [RegistrationStepOptionMode.REQUIRED, RegistrationStepOptionMode.OPTIONAL]
      },
      {
        label: StaticRegistrationStepOptionLabel.YOUR_TOP_MYTHIC_PLUS_SCORE_DOES_NOT_EXCEED,
        supportsModes: [RegistrationStepOptionMode.REQUIRED, RegistrationStepOptionMode.OPTIONAL]
      },
      {
        label: StaticRegistrationStepOptionLabel.IDEAL_SCORE_MIN_VALUE,
        supportsModes: [RegistrationStepOptionMode.OPTIONAL]
      },
      {
        label: StaticRegistrationStepOptionLabel.IDEAL_SCORE_MAX_VALUE,
        supportsModes: [RegistrationStepOptionMode.OPTIONAL]
      },
      {
        label: StaticRegistrationStepOptionLabel.IDEAL_SCORE_TICKETS,
        supportsModes: [RegistrationStepOptionMode.OPTIONAL]
      }
    ]
  }
];

export const WOWRETAIL_EVENT_CONFIG: IGameEventConfig = {
  registrationSteps: REGISTRATION_STEPS
};
